import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@chatterbug/aaron'

import Separator from './subcomponents/Separator'
import { Button } from '@chatterbug/theme'

const ACTION_STYLES = {
  color: 'blue42',
  ':hover, :active, :focus': {
    textDecoration: 'none',
    color: 'blue30',
    cursor: 'pointer',
  },
}

const BUTTON_RESET_STYLES = {
  margin: 0,
  padding: 0,
  border: 0,
  backgroundColor: 'transparent',
  color: 'blue42',
  overflow: 'hidden',
  ...ACTION_STYLES,
}

const ActionLink = ({ children, href }) => {
  return (
    <Box as="a" href={href} variant="text.buttonTitle" sx={ACTION_STYLES}>
      {children}
    </Box>
  )
}

ActionLink.propTypes = {
  href: PropTypes.string.isRequired,
}

const ActionButton = ({ children, onClick }) => {
  return (
    <Box
      as="button"
      type="button"
      variant="text.buttonTitle"
      onClick={() => onClick()}
      sx={BUTTON_RESET_STYLES}
    >
      {children}
    </Box>
  )
}

ActionButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

const Action = ({ children, separator, href, onClick }) => {
  if (href) {
    return (
      <>
        <Button as="link" kind="tertiary" href={href}>
          {children}
        </Button>
        {separator && <Separator />}
      </>
    )
  }

  if (onClick) {
    return (
      <>
        <Button as="submit" kind="tertiary" onClick={onClick}>
          {children}
        </Button>
        {separator && <Separator />}
      </>
    )
  }

  return null
}

Action.propTypes = {
  separator: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func,
}

export default Action
